export function assertString(value: unknown): asserts value is string {
  if (!(value || typeof value === 'string')) {
    throw new Error(`Expected a string, but got ${typeof value}`);
  }
}

export function assertNonNullable<T>(value: T): asserts value is NonNullable<T> {
  if (!value) {
    throw new Error(`Expected a non-nullable, but got ${typeof value}`);
  }
}
